import React from "react";

import Form, {
  ButtonItem,
  EmptyItem,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "starfx/react";

import { SideGroupTitle } from "@app/components/groupTitle";
import { schema } from "@app/statefx/schema";
import { TWhoami } from "@app/statefx/schema/app.def";
import { sfxUpdateWhoami } from "@app/statefx/xThunks/app";

export const UserConfigForm = () => {
  const frmRef = React.useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dataset = useSelector(schema.whoami.select);

  const buttonOptions = {
    text: "Salveaza",
    type: "normal" as const,
    stylingMode: "outlined" as const,
    icon: "save",
    useSubmitBehavior: true,
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    console.log("onFormSubmit", frmRef.current.instance().option("formData"));
    const whoami = frmRef.current.instance().option("formData") as TWhoami;
    dispatch(sfxUpdateWhoami(whoami));
    e.stopPropagation();
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "auto" }}>
      <SideGroupTitle title={t("userconfig_title")} sideKey={"licenseForm"} />
      <form onSubmit={onFormSubmit}>
        <Form
          ref={frmRef}
          labelMode="floating"
          labelLocation="top"
          formData={dataset}
          readOnly={true}
          colCount={2}
        >
          <SimpleItem dataField="Prenume">
            <RequiredRule message="Prenumele este obligatoriu" />
          </SimpleItem>
          <SimpleItem dataField="Nume">
            <RequiredRule message="Numele este obligatoriu" />
          </SimpleItem>
          <EmptyItem visible={false} />

          <ButtonItem
            horizontalAlignment="left"
            buttonOptions={buttonOptions}
            visible={false}
          />

          <SimpleItem
            colSpan={2}
            render={() => (
              <React.Fragment>
                <div className="notes-2">
                  <p>
                    Nota: Pentru a modifica datele de acces va rugam sa folositi
                    interfata din aplicatia Jurnal Gold Admin Panel.
                  </p>
                  <p>
                    Aceasta este disponibila la adresa
                    `&quot;https://admin.jurnalgold.ro`&quot;
                  </p>
                </div>
              </React.Fragment>
            )}
          />
        </Form>
      </form>
    </div>
  );
};
